module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Cash Receipts","noReceipts":"No receipts."},"es":{"title":"Recibos de efectivo","noReceipts":"Sin recibos de efectivo."},"sw":{"title":"Stakabadhi za pesa taslimu","noReceipts":"Hakuna risiti."}}')
  delete Component.options._Ctor
}
